import { render, staticRenderFns } from "./Account-Settings.vue?vue&type=template&id=11033144&scoped=true&"
import script from "./Account-Settings.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Account-Settings.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Account-Settings.vue?vue&type=style&index=0&id=11033144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11033144",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VImg,VTooltip})
